<template>
<v-card flat >
  <v-card-text>
    <v-text-field
      type='number'
      filled
      v-model='openingBalance'
      persistent-hint clearable
      :prefix='$store.getters.settings.currency'
      :label="$t('inputs.opening.label')"
      :hint="$t('inputs.opening.hint')" >
    </v-text-field>
    <v-layout class='mt-2' >
      <v-flex xs12 sm6 >
        <v-dialog persistent
          ref="dialog" v-model="date_modal" width="290px" >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field persistent-hint readlonly clearable
              placeholder='yyyy-mm-dd'
              hint='Choose an invoice date, or leave blank to use the latest invoice date from the selected invoices'
              v-model='date'
              label='invoice date'
              class='mr-2'
              prepend-icon='event'
              v-bind="attrs"
              v-on="on" />
          </template>
          <v-date-picker v-model="date" >
            <v-btn @click='date_modal=false' small text flat >Cancel</v-btn>
          </v-date-picker>
        </v-dialog>

      </v-flex>
      <v-flex xs12 sm6 >
        <v-dialog persistent v-model="due_date_modal" width="290px" >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field persistent-hint readlonly clearable
              placeholder='yyyy-mm-dd'
              hint='Choose a due date, or leave blank to use the latest invoice due date from the selected invoices'
              v-model='due_date'
              label='due date'
              class='mr-2'
              prepend-icon='event'
              v-bind="attrs"
              v-on="on" />
          </template>
          <v-date-picker v-model="due_date" :min='date' >
            <v-btn @click='due_date_modal=false' small text flat >Cancel</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-card-text>
  <v-list dense subheader two-line >
    <v-subheader class='overline' >
      {{ $t('subtitles.invoices') }}
    </v-subheader>
    <template v-for='invoice in invoices' >
      <v-list-tile :key='invoice.id' >
        <v-list-tile-action class='mr-2' >
          #{{invoice.id}}
        </v-list-tile-action>
        <v-list-tile-content >
          <v-list-tile-title class='hidden-xs-only' >
            {{invoice.title}}
          </v-list-tile-title>
          <v-list-tile-sub-title >
            <strong>Date:</strong> {{invoice.date}}.
            <strong>Due:</strong> {{invoice.due_date}}
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action class='hidden-xs-only mr-2' >
          <strong>{{ formatCurrency(currency, invoice.invoice_amount) }}</strong>
          <v-list-tile-action-text>
            {{ $t('subtitles.invoiced') }}
          </v-list-tile-action-text>
        </v-list-tile-action>
        <v-list-tile-action class='hidden-xs-only' >
          {{ formatCurrency(currency, invoice.amount_paid) }}
          <v-list-tile-action-text>
            {{ $t('subtitles.payments') }}
          </v-list-tile-action-text>
        </v-list-tile-action>
        <v-divider class='ml-2' vertical ></v-divider>
        <v-list-tile-action class='grey lighten-4 px-1' >
          <strong>{{ formatCurrency(currency, (invoice.invoice_amount - invoice.amount_paid)) }}</strong>
          <v-list-tile-action-text>
            {{ $t('subtitles.due') }}
          </v-list-tile-action-text>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
    </template>
  </v-list>
  <v-card-text>
    <v-layout>
      <v-flex xs12 sm4 >
        <v-btn @click='showNotes = true' v-if='!showNotes' small flat >
          <v-icon small >add</v-icon>
          {{ $t('buttons.note') }}
        </v-btn>
        <template v-else >
          <h4 class='overline ml-1' >{{ $t('subtitles.notes') }}</h4>
          <v-textarea filled box v-model='notes' class='ma-1 mr-2' filled label='Add a note' >
          </v-textarea>
        </template>
      </v-flex>
      <v-flex xs12 sm8 >
        <v-layout class='text-xs-right' >
          <v-flex xs7 sm10 class='text-uppercase' >
            {{ $t('subtitles.opening') }}
          </v-flex>
          <v-flex xs5 sm2 >{{ formatCurrency(this.currency, openingBalance) }}</v-flex>
        </v-layout>
        <v-layout class='text-xs-right' >
          <v-flex xs7 sm10 class='text-uppercase' >
            {{ $t('subtitles.invoiced') }}
          </v-flex>
          <v-flex xs5 sm2 >{{ formatCurrency(this.currency, invoiceTotal) }}</v-flex>
        </v-layout>
        <v-layout class='text-xs-right mb-2'>
          <v-flex xs7 sm10 class='text-uppercase' >
            {{ $t('subtitles.payments') }}
          </v-flex>
          <v-flex xs5 sm2>{{ formatCurrency(this.currency, paymentsTotal) }}</v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout class='text-xs-right mt-2 subtitle-1 text-uppercase'>
          <v-flex xs7 sm10 ><strong>{{ $t('subtitles.total') }}</strong></v-flex>
          <v-flex xs5 sm2 class='text-right' >
            <strong>
              {{ formatCurrency(this.currency, grandTotal) }}
            </strong>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card-text>
  <v-card-actions >
    <v-spacer></v-spacer>
    <v-btn
      :disabled='noInvoices'
      :loading='statementRequest.loading'
      @click='create'
      color='primary' >{{ $t('buttons.create') }}
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
// import CrudMixin from '@/components/datatools/mixins/crudmixin'

export default {
  name: 'InvoiceStatementForm',
  props: {
    relationshipId: { required: true },
    invoices: { type: Array, required: true }
  },
  data () {
    return {
      showNotes: false,
      notes: null,
      openingBalance: 0,
      date: null,
      date_modal: false,
      due_date: null,
      due_date_modal: false,
      createReqId: 'create-invoice-request',
      requests: {
        create: {
          service: 'invoiceguru',
          path: '/statements/',
          method: 'post',
          status: 0,
          params: {},
          data: {},
          response: {}
        }
      }
    }
  },
  computed: {
    currency () {
      return this.$store.getters.settings.currency
    },
    invoiceTotal () {
      return this.invoices.reduce((total, currentValue, currentIndex, arr) => {
        let item = arr[currentIndex]
        total += parseFloat(item.invoice_amount)
        return total
      }, 0)
    },
    noInvoices () {
      return (!this.invoices || this.invoices.length === 0)
    },
    paymentsTotal () {
      return this.invoices.reduce((total, currentValue, currentIndex, arr) => {
        let item = arr[currentIndex]
        total += parseFloat(item.amount_paid)
        return total
      }, 0)
    },
    grandTotal () {
      let opening = parseFloat(this.openingBalance)
      if (isNaN(opening)) { opening = 0 }
      return this.invoiceTotal - this.paymentsTotal + opening
    },
    groupedStatements () {
      let res = {}
      this.invoices.forEach((invoice) => {
        let relationshipId = invoice.relationship_id
        if (!(relationshipId in res)) { res[relationshipId] = [] }
        res[relationshipId].push(invoice)
      })
      return res
    },
    invoiceIds () {
      return this.invoices.map((invoice) => {
        return invoice.id
      })
    },
    payload () {
      return {
        relationship_id: this.relationshipId,
        invoices: this.invoiceIds.join(','),
        notes: this.notes,
        opening_balance: this.openingBalance,
        date: this.date,
        due_date: this.due_date
      }
    },
    statementRequest () {
      return this.$store.getters.getRequestById(this.createReqId, true)
    },
    statementRequestStatus () {
      return this.statementRequest.status
    },
    createdStatement () {
      return this.getObjectPath(this.statementRequest, 'result.data')
    }
  },
  watch: {
    statementRequestStatus () {
      if (this.statementRequestStatus === 201) {
        this.$emit('success', this.createdStatement)
      }
    },
    invoices () {
      this.date = null
      this.due_date = null
    },
    date () {
      this.date_modal = false
    },
    due_date () {
      this.due_date_modal = false
    }
  },
  methods: {
    create () {
      this.requests.create.data = this.payload
      this.$invoiceguru
        .resource('statements')
        .id(this.createReqId)
        .create(this.requests.create.data)
      // this.performRequest('create')
    }
  },
  i18n: {
    messages: {
      en: {
        inputs: {
          opening: {
            label: 'Opening balance',
            hint: 'This is the opening balance for the statement, and will be added to the total cost of the invoices included.'
          }
        },
        subtitles: {
          invoices: 'Invoices included in this statement',
          payments: 'Paid',
          invoiced: 'Invoiced',
          due: 'Due',
          opening: 'Opening balance',
          total: 'Closing balance',
          notes: 'Notes'
        },
        buttons: {
          create: 'Create Statement',
          preview: 'Preview',
          note: 'Add a note'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreateStatementForm.vue?ff4343d2